import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { loadUploadsStatsBarChartData } from "../redux/action";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const UploadStatsBarChart = () => {
    const dispatch = useDispatch();
    const { uploadStatsBarChartData } = useSelector((state) => state.data);

    const [timeRange, setTimeRange] = useState("week");
    const [chartData, setChartData] = useState({
        labels: [],
        datasets: [],
    });

    // 🔹 Call API whenever timeRange changes
    useEffect(() => {
        dispatch(loadUploadsStatsBarChartData(timeRange));
    }, [dispatch, timeRange]);

    // 🔹 Update chart when API data changes
    useEffect(() => {
        if (!uploadStatsBarChartData || uploadStatsBarChartData.length === 0) return;

        const labels = uploadStatsBarChartData.map((d) => d.label);

        setChartData({
            labels,
            datasets: [
                { label: "Fresh", data: uploadStatsBarChartData.map((d) => d.fresh), backgroundColor: "#4caf50" },
                { label: "Repeated", data: uploadStatsBarChartData.map((d) => d.repeated), backgroundColor: "#2196f3" },
                { label: "Invalid", data: uploadStatsBarChartData.map((d) => d.invalid), backgroundColor: "#f44336" },
                { label: "Duplicate", data: uploadStatsBarChartData.map((d) => d.duplicate), backgroundColor: "#ff9800" },
                { label: "Invalid Locations", data: uploadStatsBarChartData.map((d) => d.invalid_locations), backgroundColor: "#9c27b0" },
            ],
        });
    }, [uploadStatsBarChartData]);

    return (
        <div className="upload-stats-barchart-container">
            <div className="upload-stats-barchart-header">
                <h5>Upload Stats</h5>
            </div>

            {/* 🔹 Time range filter */}
            <div className="bar-chart-option-container">
                <select value={timeRange} onChange={(e) => setTimeRange(e.target.value)}>
                    <option value="week">Week</option>
                    <option value="month">Month</option>
                    <option value="3months">3 Months</option>
                    <option value="6months">6 Months</option>
                    <option value="year">Year</option>
                </select>
            </div>

            {/* 🔹 Chart */}
            <div className="barchart-container">
                <Bar
                    data={chartData}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: { position: "top" },
                            title: { display: true, text: "Upload Statistics" },
                        },
                    }}
                />
            </div>
        </div>
    );
};

export default UploadStatsBarChart;
